<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="smartptomlist" label="项目列表"></TabPane>
            <TabPane name="smartptomplan" label="计划列表" v-if="isPlan"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'policylayout',
  computed: {
    isPlan() {
      return this.currentRoute === 'smartptomplan'
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      if (this.$route.name === 'smartptom') this.changeRouter('smartptomlist')
      this.currentRoute = this.$route.name
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      currentRoute: ''
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
